import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaddaModule } from 'angular2-ladda';
import { TranslateModule } from "@ngx-translate/core";

import { InternalFacilitiesRoutingModule } from './internal-facilities-routing.module';
import { EmailSignatureComponent } from './components/email-signature/email-signature.component';
import { InternalFacilitiesMainComponent } from './containers/internal-facilities-main/internal-facilities-main.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AiAssistantComponent } from './components/ai-assistant-main/ai-assistant-main.component';
import { AiAssistantTableComponent } from './components/ai-assistant-table/ai-assistant-table.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CreateDictionaryPopupComponent } from './components/create-dictionary-popup/create-dictionary-popup.component';
import { UpdateDictionaryPopupComponent } from './components/update-dictionary-popup/update-dictionary-popup.component';
import { CreateUpdateDictionaryFormComponent } from './components/create-update-dictionary-form/create-update-dictionary-form.component';
import { FeatureFlagsComponent } from './components/feature-flags/feature-flags.component';
import { FeatureFlagsTableComponent, AddEditFlagModalComponent, AddEditFlagFormComponent, FlagUsageModalComponent, FlagsCompanyTableComponent } from './components/feature-flags/components';

@NgModule({
  declarations: [
    EmailSignatureComponent,
    InternalFacilitiesMainComponent,
    AiAssistantComponent,
    AiAssistantTableComponent,
    CreateDictionaryPopupComponent,
    UpdateDictionaryPopupComponent,
    CreateUpdateDictionaryFormComponent,
    FeatureFlagsComponent,
    FeatureFlagsTableComponent,
    AddEditFlagModalComponent,
    AddEditFlagFormComponent,
    FlagUsageModalComponent,
    FlagsCompanyTableComponent
  ],
  imports: [
    InternalFacilitiesRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgbTooltipModule,
    TranslateModule.forChild(),
    LaddaModule.forRoot({
      spinnerColor: 'grey',
      style: 'zoom-in'
    }),
    NgxSkeletonLoaderModule,
    SharedModule
  ],
  entryComponents: [
    CreateDictionaryPopupComponent,
    UpdateDictionaryPopupComponent
  ]
})
export class InternalFacilitiesModule { }
